// Do NOT use NODE_ENV. Use GATSBY_HOSTING_ENVIRONMENT instead.
// Values: 'local', 'dev', 'stage', OR 'prod'
export const HOSTING_ENVIRONMENT = process.env.REACT_APP_HOSTING_ENVIRONMENT;

export const LEVER_ENDPOINT = 'https://api.lever.co/v0/postings/lucidmotors';

// Main Configurator frontend endpoint for ZeroLight
export const CONFIGURATOR_ENDPOINT =
  HOSTING_ENVIRONMENT == 'prod'
    ? 'https://sitebuild-web-live.lucid.zlthunder.net'
    : HOSTING_ENVIRONMENT == 'stage'
    ? 'https://sitebuild-web-test.lucid.zlthunder.net'
    : 'https://sitebuild-web-test.lucid.zlthunder.net';

// ZeroLight CMF endpoint
export const CONFIGURATOR_CMF_ENDPOINT =
  HOSTING_ENVIRONMENT == 'prod'
    ? 'https://sitebuild-cmf-live.lucid.zlthunder.net'
    : HOSTING_ENVIRONMENT == 'stage'
    ? 'https://sitebuild-cmf-test.lucid.zlthunder.net'
    : 'https://sitebuild-cmf-test.lucid.zlthunder.net';

// RenderChain API endpoint for ZeroLight
// Used to retrieve a preview image for a given configuration shortcode
export const CONFIGURATOR_IMAGE_ENDPOINT =
  HOSTING_ENVIRONMENT === 'prod'
    ? 'https://lucidmotors.com/portalapi/images/vehicle'
    : HOSTING_ENVIRONMENT === 'stage'
    ? 'https://stage.dslmotors.com/portalapi/images/vehicle'
    : 'https://stage.dslmotors.com/portalapi/images/vehicle';

// WebGL endpoint from HMX
export const CONFIGURATOR_WEBGL_ENDPOINT =
  'https://content.hmxmedia.com/Lucid/Air/index.html';

export const SALESFORCE_OID =
  HOSTING_ENVIRONMENT == 'prod' ? '00D36000000p5Xr' : '00D5C000000124F';

export const SALESFORCE_ENDPOINT =
  HOSTING_ENVIRONMENT == 'prod'
    ? 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8'
    : 'https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8';

export const API_ENDPOINTS = {
  FORMS: `${process.env.REACT_APP_API_URI}/forms`,
  STRIPE_INTENT: `${process.env.REACT_APP_API_URI}/stripe/intent`,
  STRIPE_PUBKEY: `${process.env.REACT_APP_API_URI}/stripe/pubkey`,
  AUTHED_RESERVE: `${process.env.REACT_APP_API_URI}/authed-reserve`,
  USER: `${process.env.REACT_APP_API_URI}/user`,
  MAPS:
    HOSTING_ENVIRONMENT == 'prod'
      ? `${process.env.REACT_APP_API_URI}/data/maps`
      : `https://api.stage.dslmotors.com/data/maps`, // so we can QA on Dev/local until Salesforce Dev is fixed
};

export const CUSTOMERGATEWAY_BASE_URL =
  HOSTING_ENVIRONMENT === 'prod'
    ? 'https://customerportal.deneb.prod.infotainment.pdx.atieva.com/v1'
    : HOSTING_ENVIRONMENT === 'stage'
    ? 'https://customerportal.algol.staging.infotainment.pdx.atieva.com/v1'
    : HOSTING_ENVIRONMENT === 'qa'
    ? 'https://gateway.franz.qa.infotainment.pdx.atieva.com/customergateway/v1'
    : 'https://gateway.franz.qa.infotainment.pdx.atieva.com/customergateway/v1';

export const API = {
  PROFILE: `${process.env.REACT_APP_API_URI}/profile`,
  USER_RESERVE: `${process.env.REACT_APP_API_URI}/authed-reserve`,
  ANON_RESERVE: `${process.env.REACT_APP_API_URI}/user`,
  RESERVATION_UPGRADE: `${process.env.REACT_APP_API_URI}/user/reservation/upgrade`,
  RESERVATION_WAITLIST: `${process.env.REACT_APP_API_URI}/user/reservation/waitlist`,
  FORMS: `${process.env.REACT_APP_API_URI}/forms`,
  LEADS: `${process.env.REACT_APP_API_URI}/leads`,
  STRIPE_INTENT: `${process.env.REACT_APP_API_URI}/stripe/intent`,
  PAYMENT_CONFIG: `${process.env.REACT_APP_PAYMENT_API_URI}/api/payments/config`,
  STRIPE_KEYS: `${process.env.REACT_APP_API_URI}/stripe/keys`,
  ORDER_INFORMATION: `${process.env.REACT_APP_API_URI}/order`,
  ORDER_CONFIRM: `${process.env.REACT_APP_API_URI}/order/confirm`,
  ORDER_DOCUMENTS: `${process.env.REACT_APP_API_URI}/order/documents`,
  WEBTOCASE: `${process.env.REACT_APP_API_URI}/webtocase`,
};

export const PAYMENT_API_URI =
  process.env.REACT_APP_PAYMENT_API_URI ||
  'https://payment-service.commerce.stage.lucidgroup.com';

export const CART_API_URI =
  process.env.REACT_APP_CART_API_URI ||
  'https://cfs.app.us.stage.lucidgroup.com/cart-manager';

export const BACKEND_API_URI =
  process.env.REACT_APP_BACKEND_API_URI || 'http://localhost:8080';

export const BIGCOMMERCE_STORE_URL =
  process.env.BIGCOMMERCE_STORE_URL ||
  'https://sandbox-lucid-motors-1.mybigcommerce.com';

export const LOAN_LEASE_DEFI_URI =
  process.env.REACT_APP_LOAN_LEASE_DEFI_URI ||
  'https://ac-test00.autolendingapps.com/lucido/AutoOrigination/CreditApp';

export const LOAN_LEASE_BUSINESS_FINANCING_URI =
  process.env.LOAN_LEASE_BUSINESS_FINANCING_URI ||
  'https://www.bankofamerica.com/smallbusiness/business-financing/auto-loans/';

export const GIGYA_PUBLIC_KEY =
  HOSTING_ENVIRONMENT === 'prod'
    ? '3_LsnGbh7DbHN1GvGRYF1rjK5l39uzJZ8clmkKEucFyozppJDdCkkW21t-utYy17Km'
    : HOSTING_ENVIRONMENT === 'stage'
    ? '3_tC0Hb6W437yNUk1XMt_b4vMDusCLkzofJFmkNdKEiHBOHSL5MKG86jjfbzA68_Pw'
    : '3_ko6qML_w4KMn6hITBe20_fu_EMeKA3l9wM2cB8Ig1O-lGtr2DjEIbMp8u4lw807B';

export const PAYMENT_PAGE_ENABLED =
  process.env.GATSBY_PAYMENT_PAGE_ENABLED === 'true' || true;

export const ACTIVE_VEHICLE_ID_COOKIE = 'ACTIVE_VEHICLE_ID';

export const TRIMS_PARAMETERS = {
  'Lucid Air Dream Edition': 'dream_edition',
  'Lucid Air Grand Touring': 'grand_touring',
  'Lucid Air Touring': 'touring',
  'Lucid Air Pure': 'air',
};

export const TRIM_UPGRADES_AVAILABLE = {
  'Lucid Air Dream Edition': [],
  'Lucid Air Grand Touring': ['Lucid Air Dream Edition'],
  'Lucid Air Touring': ['Lucid Air Grand Touring', 'Lucid Air Dream Edition'],
  'Lucid Air Pure': [
    'Lucid Air Touring',
    'Lucid Air Grand Touring',
    'Lucid Air Dream Edition',
  ],
};

export const TRIMS = {
  'Lucid Air Dream Edition': 'Lucid Air Dream Edition',
  'Lucid Air Grand Touring': 'Lucid Air Grand Touring',
  'Lucid Air Touring': 'Lucid Air Touring',
  'Lucid Air Pure': 'Lucid Air Pure',
  dream_edition: 'Lucid Air Dream Edition',
  grand_touring: 'Lucid Air Grand Touring',
  touring: 'Lucid Air Touring',
  air: 'Lucid Air Pure',
};

export const TRIM_AVAILABILITY = {
  'Lucid Air Dream Edition': ['US', 'CA'],
  'Lucid Air Grand Touring': [
    'US',
    'AT',
    'BE',
    'CA',
    'DK',
    'FI',
    'FR',
    'DE',
    'IS',
    'IT',
    'MC',
    'NL',
    'NO',
    'SA',
    'ES',
    'SE',
    'CH',
    'AE',
    'GB',
  ],
  'Lucid Air Touring': [
    'US',
    'AT',
    'BE',
    'CA',
    'DK',
    'FI',
    'FR',
    'DE',
    'IS',
    'IT',
    'MC',
    'NL',
    'NO',
    'SA',
    'ES',
    'SE',
    'CH',
    'AE',
    'GB',
  ],
  'Lucid Air Pure': [
    'US',
    'AT',
    'BE',
    'CA',
    'DK',
    'FI',
    'FR',
    'DE',
    'IS',
    'IT',
    'MC',
    'NL',
    'NO',
    'SA',
    'ES',
    'SE',
    'CH',
    'AE',
    'GB',
  ],
};

// NPM package version
// TODO: Need to leverage process.env.npm_package_version in client
export const RELEASE_VERSION = '0.1.0 ';

// Gigya endpoint
export const GIGYA_ENDPOINT = 'https://cdns.gigya.com/js/gigya.js';

export const LIVECHAT_CONFIG =
  HOSTING_ENVIRONMENT === 'prod'
    ? {
        id: '5731Q0000008uHn',
        apiURL: 'https://d.la1-c1-ph2.salesforceliveagent.com/chat',
        apiId1: '5721Q0000008rec',
        apiId2: '00D36000000p5Xr',
      }
    : HOSTING_ENVIRONMENT === 'stage'
    ? {
        id: '5731b000000CafO',
        apiURL: 'https://d.la4-c1cs-dfw.salesforceliveagent.com/chat',
        apiId1: '5721b000000Carj',
        apiId2: '00D1b00000095fK',
      }
    : HOSTING_ENVIRONMENT === 'qa'
    ? {
        id: '5731b000000CafO',
        apiURL: 'https://d.la4-c1cs-dfw.salesforceliveagent.com/chat',
        apiId1: '5721b000000Carj',
        apiId2: '00D1b00000095fK',
      }
    : {
        id: '5732h0000008PBv',
        apiURL: 'https://d.la3-c1cs-ph2.salesforceliveagent.com/chat',
        apiId1: '5722h0000008Owr',
        apiId2: '00D2h0000008gnF',
      };

export const TRIMS_UPGRADABLE = [
  'Lucid Air Grand Touring',
  'Lucid Air Touring',
  'Lucid Air Pure',
];

export const TRIM_CHANGE_AVAILABLE = {
  'Lucid Air Dream Edition': ['Lucid Air Dream Edition'],
  'Lucid Air Grand Touring': ['Lucid Air Grand Touring'],
  'Lucid Air Touring': ['Lucid Air Touring'],
  'Lucid Air Pure': ['Lucid Air Pure'],
};

export const TRIM_INFO = {
  'Lucid Air Dream Edition': {
    name: {
      en: 'Air Dream Edition (Limited)',
      ar: 'أير دريم إديشن(محدودة)',
      zh: 'Air Dream Edition (Limited)',
    },
  },
  'Lucid Air Grand Touring': {
    name: {
      en: 'Air Grand Touring',
      ar: 'أير جراند تورنج',
      zh: 'Air Grand Touring',
    },
  },
  'Lucid Air Touring': {
    name: {
      en: 'Air Touring',
      ar: 'أير تورنج',
      zh: 'Air Touring',
    },
  },
  'Lucid Air Pure': {
    name: {
      en: 'Air Pure',
      ar: 'أير',
      zh: 'Air Pure',
    },
  },
};

export const ORDER_CONFIRMATION_ENABLED =
  process.env.GATSBY_ORDER_CONFIRMATION_ENABLED === 'true' || false;
export const LUCID_LOGO_ANIMATION_ENABLED =
  process.env.GATSBY_LUCID_LOGO_ANIMATION_ENABLED === undefined ||
  process.env.GATSBY_LUCID_LOGO_ANIMATION_ENABLED === 'true';
export const ECOMMERCE_COMPONENT_ENABLED_LOCALES =
  process.env.ECOMMERCE_COMPONENT_ENABLED_LOCALES?.split(',') || ['en'];

//TO DO
